import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import UserReportAbnormallyDetail from '../components/report/UserReportAbnormallyDetail';

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ userReportDetails, loading, intl, dispatch }) => {
    return (
      <div className="container-left">
        <UserReportAbnormallyDetail
          intl={intl}
          dispatch={dispatch}
          loading={loading}
          userReportDetails={userReportDetails}
        />
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/UserAbnormalDetail.js